import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Onboarding store with localStorage persistence
 * Tracks user onboarding state and guide preferences
 */
export const useOnboardingStore = create(
  persist(
    (set) => ({
      // User email
      userEmail: null,

      // Guide visibility flag (for future implementation)
      shouldShowGuide: true,

      // First time login flag
      firstTimeLogin: true,

      // Actions
      setUserEmail: (email) => set({ userEmail: email }),

      setShouldShowGuide: (show) => set({ shouldShowGuide: show }),

      setFirstTimeLogin: (isFirst) => set({ firstTimeLogin: isFirst }),

      // Reset onboarding state
      resetOnboarding: () =>
        set({
          userEmail: null,
          shouldShowGuide: true,
          firstTimeLogin: true,
        }),

      // Mark onboarding as completed
      completeOnboarding: () =>
        set({
          shouldShowGuide: false,
          firstTimeLogin: false,
        }),
    }),
    {
      name: 'onboarding-storage', // localStorage key
      version: 1, // version for migration
    }
  )
);
